import { showNotification } from "@mantine/notifications";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { customAxios } from "lib/axios";

export interface UploadResponse {
  success: boolean;
  message: string;
  data: {
    _id: string;
    userId: string;
    organizationId?: string;
    fileName: string;
    originalName: string;
    mimeType: string;
    size: number;
    url: string;
    fileType: "image" | "document" | "video" | "audio" | "other";
    createdAt: string;
  };
}

const uploadFile = async (file: File): Promise<UploadResponse> => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await customAxios.post<UploadResponse>(
    "/upload",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
  return data;
};

export const useUploadFile = () =>
  useMutation<UploadResponse, AxiosError, File>(uploadFile, {
    onSuccess: (response) => {
      showNotification({
        title: "Upload successful",
        message: response.message || "File uploaded successfully",
        color: "green",
      });
    },
    onError: (error) => {
      const errorMessage =
        (error.response?.data as { message?: string })?.message ||
        "Failed to upload file";
      showNotification({
        title: "Upload failed",
        message: errorMessage,
        color: "red",
      });
    },
  });
